/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Intro_P2Inputs */

const es_marketplace_seo_spain_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanto si buscas un día de navegación a vela como un barco a motor para descubrir calas, aquí encontrarás opciones verificadas con reseñas de otros navegantes.`)
};

const gl_marketplace_seo_spain_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanto se buscas un día de navegación a vela como un barco a motor para descubrir calas, aquí atoparás opcións verificadas con reseñas doutros navegantes.`)
};

const en_marketplace_seo_spain_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether you want a sailing day or a motorboat to explore coves, you will find verified listings with reviews from other boaters.`)
};

/**
* | output |
* | --- |
* | "Whether you want a sailing day or a motorboat to explore coves, you will find verified listings with reviews from other boaters." |
*
* @param {Marketplace_Seo_Spain_Guide_Intro_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_intro_p2 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Intro_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Intro_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_intro_p2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_intro_p2(inputs)
	return es_marketplace_seo_spain_guide_intro_p2(inputs)
});